export default {
  siteName: "USFansSheet",
  navHome: "Strona główna",
  navShoppingGuide: "Poradnik zakupowy",
  navSpreadsheet: "Arkusz",
  navCategories: "Kategorie",
  navGuides: "Poradniki",
  navFAQ: "FAQ",
  ctaExplore: "Przeglądaj arkusz",
  ctaBuyNow: "Kup teraz",
  ctaMainSite: "Odwiedź główną stronę",
  dropdownLabel: "Przeglądaj kategorie",
  dropdownPlaceholder: "Wybierz kategorię…",
  footerTagline:
    "Niezależne centrum zasobów USFans Spreadsheet — pomaga odkrywać znaleziska, porównywać opcje i kupować mądrzej.",
  footerQuickLinks: "Szybkie linki",
  footerCategories: "Kategorie",
  footerLegal: "Informacje prawne",
  footerHome: "Strona główna",
  footerGuide: "Przewodnik USFans Spreadsheet",
  footerAbout: "O nas",
  footerContact: "Kontakt",
  footerPrivacy: "Polityka prywatności",
  footerDisclaimer: "Zastrzeżenie",
  footerAffiliate: "Ujawnienie afiliacyjne",
  externalNote: "Linki zewnętrzne otwierają się w nowej karcie.",
  copyright: "USFansSheet. Wszelkie prawa zastrzeżone.",
  notFoundTitle: "Nie znaleziono strony",
  notFoundDesc: "Strona, której szukasz, nie istnieje lub została przeniesiona. Wróć na stronę główną, aby kontynuować.",
  notFoundCta: "Wróć do strony głównej",
  disclaimer:
    "USFansSheet to niezależne źródło informacji, które nie jest powiązane z USFans, nie jest przez nie popierane ani nie jest oficjalną stroną USFans. Wszystkie linki do produktów prowadzą do zewnętrznych witryn.",
  categories: {
    shoes: "Buty",
    hoodiesSweaters: "Bluzy / Swetry",
    tShirts: "Koszulki",
    jackets: "Kurtki",
    pantsShorts: "Spodnie / Szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna / Majtki",
    jersey: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    otherStuff: "Inne rzeczy",
  },
};